import { render, staticRenderFns } from "./arrange.vue?vue&type=template&id=083c372e&lang=pug&"
import script from "./arrange.vue?vue&type=script&lang=js&"
export * from "./arrange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('083c372e', component.options)
    } else {
      api.reload('083c372e', component.options)
    }
    module.hot.accept("./arrange.vue?vue&type=template&id=083c372e&lang=pug&", function () {
      api.rerender('083c372e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/arrange.vue"
export default component.exports